export const GET_MODELS = 'GET_MODELS';
export const GET_OFFERS_FULL = 'GET_OFFERS_FULL';
export const GET_DISCLAIMER = 'GET_DISCLAIMER';
export const GET_VEHICLE = 'GET_VEHICLE';
export const GET_SME_DESCRIPTIONS = 'GET_SME_DESCRIPTIONS';
export const GET_BODY = 'GET_BODY';
export const GET_MANUFACTURERS = 'GET_MANUFACTURERS';
export const GET_RANGES = 'GET_RANGES';
export const GET_FUEL_TYPES = 'GET_FUEL_TYPES';
export const EXECUTE_FILTER = 'EXECUTE_FILTER';